<template>
  <div class="container">
    <div class="boxtit">
      添加成交數據
    </div>
    <div
      class="boxcon"
      v-html="phoneDeal"
    />
    <el-form
      ref="dealFormData"
      :model="dealFormData"
      :rules="rules"
      label-width="218px"
    >
      <div class="firbox">
        <h3>關聯放盤信息</h3>
        <div class="content">
          <el-form-item label="是否曾在House730放盤">
            <el-radio-group
              v-model="dealFormData.isHouseProperty"
              :disabled="$route.query.type == 'edit'"
              class="onlyChoose"
              @change="changeIsHouse"
            >
              <el-radio :label="true">
                是
              </el-radio>
              <el-radio :label="false">
                否
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="House730放盤所用樓盤編號">
            <el-input
              v-model="dealFormData.propertyID"
              :disabled="!dealFormData.isHouseProperty || $route.query.type == 'edit'"
              class="w180"
              maxlength="20"
            />
            <el-button
              :disabled="$route.query.type == 'edit'"
              class="serBtn"
              type="primary"
              @click="seaPro(dealFormData.propertyID)"
            >
              確 定
            </el-button>
          </el-form-item>
        </div>
      </div>
      <div class="secbox">
        <h3>成交數據資料</h3>
        <div class="content">
          <el-row
            :gutter="20"
            class="cate"
          >
            <el-form-item
              label="樓盤類型"
              prop="propertyCategory"
            >
              <el-radio-group
                v-model="dealFormData.propertyCategory"
                :disabled="dealDisable"
              >
                <el-radio
                  v-for="item in diConfig.PropertyCategory"
                  :key="item.dictionaryValue"
                  :disabled="item.disable"
                  :label="item.dictionaryValue"
                  @change="setChildType(item)"
                >
                  {{ item.dictionaryNameWithCulture }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="dealFormData.propertyCategory == 5 || dealFormData.propertyCategory == 1 || dealFormData.propertyCategory == 4"
              prop="subCategory"
            >
              <el-radio-group
                v-if="dealFormData.propertyCategory == '1'"
                v-model="dealFormData.subCategory"
                :disabled="dealDisable"
                class="moreChoose"
              >
                <el-radio
                  v-for="item in diConfig.ChildrenCategory"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryValue"
                  @change="changeSub"
                >
                  {{ item.dictionaryNameWithCulture }}
                </el-radio>
              </el-radio-group>
              <el-checkbox-group
                v-else
                v-model="dealFormData.subCategory"
                :disabled="dealDisable"
                class="moreChoose"
              >
                <el-checkbox
                  v-for="citem in diConfig.ChildrenCategory"
                  :key="citem.dictionaryValue"
                  :label="citem.dictionaryValue"
                >
                  {{ citem.dictionaryNameWithCulture }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
          <el-row
            :gutter="20"
            class="propertyNo"
          >
            <el-form-item
              label="物業編號"
              prop="propertyNo"
            >
              <el-input
                ref="propertyNo"
                v-model="dealFormData.propertyNo"
                :disabled="dealDisable "
                class="w320"
                type="text"
                maxlength="20"
                @input="proChange($event)"
              />
              <span class="EAA left_10">EAA要求提供 (最多20字)</span>
            </el-form-item>
          </el-row>
          <el-row
            :gutter="20"
            class="propertyNo"
          >
            <el-form-item
              label="屋苑或大廈名稱"
              prop="estateName"
            >
              <el-autocomplete
                v-model="dealFormData.estateName"
                :disabled="dealDisable"
                class="w180 left_negative10"
                :fetch-suggestions="search"
                placeholder="搜尋：屋苑或大廈名稱"
                @select="setEstate"
                @blur="cancelSearch"
              />
            </el-form-item>
          </el-row>
          <template v-if="dealFormData.estateID!=0">
            <!-- 期数 搜索且输入了屋苑名称非村务(客制)时显示-->
            <el-row
              v-if="dealFormData.estateID!=0 && !isCutomadded && dealFormData.propertyCategory !== 5 && estAdress.phaseEstates.length"
              :gutter="20"
            >
              <el-form-item
                label="期數"
                prop="phaseWithCulture"
                :rules="dealFormData.propertyCategory == 1 ? rules.phaseWithCulture : [{ required: false }]"
              >
                <el-select
                  v-model="dealFormData.phaseWithCulture"
                  :disabled="dealDisable"
                  class="w180"
                  placeholder="請選擇期數"
                  no-data-text="暫無數據"
                >
                  <el-option
                    v-for="(item, index) in estAdress.phaseEstates"
                    :key="index"
                    :label="item.phaseWithCulture"
                    :value="item.phaseWithCulture"
                    @click.native="setPhaBuild('phase', item)"
                  />
                </el-select>
              </el-form-item>
            </el-row>
            <!-- 此row删除 会导致座数不触发校验 -->
            <el-row v-show="false" />
            <!-- 座数 楼层 -->
            <el-row
              v-if="dealFormData.propertyCategory !== '4' && dealFormData.propertyCategory !== '5'"
              :gutter="20"
              class="flexbuilA-flo"
            >
              <div class="flexbuilA">
                <el-form-item
                  label="座數"
                  prop="buildingNameWithCulture"
                  :rules="isHaveTo ? rules.buildingNameWithCulture : [{ required: false }]"
                >
                  <!-- 村务客制手输 -->
                  <el-select
                    v-if="!isCutomadded && showEstAdressbui && dealFormData.propertyCategory !== '3'"
                    v-model="dealFormData.buildingNameWithCulture"
                    :disabled="dealDisable"
                    class="w180"
                    placeholder="請選擇座數"
                    no-data-text="暫無數據"
                  >
                    <el-option
                      v-for="(item, index) in estAdress.buildings"
                      :key="index"
                      :label="item.buildingNameWithCulture"
                      :value="item.buildingNameWithCulture"
                      @click.native="setPhaBuild('build', item)"
                    />
                  </el-select>
                  <el-input
                    v-if="isCutomadded || !showEstAdressbui || dealFormData.propertyCategory == '3'"
                    v-model="dealFormData.buildingName"
                    :disabled="dealDisable"
                    class="w180"
                    @blur="setPhaBuild('isCusbuild')"
                  />
                </el-form-item>
              </div>
              <div
                ref="unitFloor"
                class="flexflo"
              >
                <el-form-item
                  label="樓層"
                  class="build-form"
                  prop="floorNameAll"
                  :rules="dealFormData.propertyCategory == '1' && dealFormData.buildingType == 1 ? rules.floorName : [{ required: false }]"
                >
                  <div class="build-Div build-Div-flo">
                    <template v-if="dealFormData.propertyCategory == '1' && dealFormData.buildingType == 1">
                      <el-select
                        v-model="dealFormData.floorName"
                        prop="floorName"
                        class="w180"
                        :disabled="oneBuilFlo || startFloDis || dealDisable"
                        placeholder="請選擇樓層"
                        no-data-text="暫無數據"
                      >
                        <el-option
                          v-for="(item, index) in estAdress.floorList"
                          :key="index"
                          :label="item.floorName"
                          :value="item.floorName"
                          @click.native="setFlo(item)"
                        />
                      </el-select>
                      <el-select
                        v-if="estAdress.unitFloorList.length"
                        v-model="dealFormData.unitFloor"
                        prop="unitFloor"
                        class="w180 build-sel"
                        :disabled="oneBuilFlo || dealDisable"
                        placeholder="請選擇高/中/低層"
                        no-data-text="暫無數據"
                      >
                        <el-option
                          v-for="(item, index) in estAdress.unitFloorList"
                          :key="index"
                          :label="item.dictionaryNameWithCulture"
                          :value="item.dictionaryValue"
                          @click.native="setFloExt"
                        />
                      </el-select>
                      <el-select
                        v-else
                        v-model="dealFormData.unitFloor"
                        class="w180 build-sel"
                        :disabled="oneBuilFlo || dealFormData.buildingType == 1 || dealDisable"
                        placeholder="請選擇高/中/低層"
                        no-data-text="暫無數據"
                      >
                        <el-option
                          v-for="item in diConfig.UnitFloor"
                          :key="item.dictionaryValue"
                          :label="item.dictionaryNameWithCulture"
                          :value="item.dictionaryValue"
                          @click.native="selPlatImg('101')"
                        />
                      </el-select>
                    </template>
                    <template v-else>
                      <el-select
                        v-model="dealFormData.unitFloor"
                        :disabled="oneBuilFlo || startFloDis||dealDisable"
                        placeholder="請選擇高/中/低層"
                        no-data-text="暫無數據"
                        class="w180"
                      >
                        <el-option
                          v-for="item in diConfig.UnitFloor"
                          :key="item.dictionaryValue"
                          :label="item.dictionaryNameWithCulture"
                          :value="item.dictionaryValue"
                          @click.native="setFloExt"
                        />
                      </el-select>
                    </template>
                  </div>
                </el-form-item>
              </div>
            </el-row>
            <!-- 车位楼层 -->
            <el-row
              v-if=" dealFormData.estateID!=0 && dealFormData.propertyCategory == '4'"
              :gutter="20"
            >
              <el-form-item label="樓層">
                <el-select
                  v-model="dealFormData.unitFloor"
                  :disabled="dealDisable"
                  placeholder="請選擇高/中/低層"
                  no-data-text="暫無數據"
                  class="w180"
                >
                  <el-option
                    v-for="item in diConfig.UnitFloor"
                    :key="item.dictionaryValue"
                    :label="item.dictionaryNameWithCulture"
                    :value="item.dictionaryValue"
                    @click.native="setFloExt"
                  />
                </el-select>
              </el-form-item>
            </el-row>
            <!-- 单位 -->
            <el-row
              v-if="dealFormData.propertyCategory !== '4' && dealFormData.propertyCategory !== '5'"
              :gutter="20"
            >
              <el-form-item
                v-if="dealFormData.propertyCategory == '1' && dealFormData.buildingType == 1"
                label="單位"
              >
                <el-select
                  v-model="dealFormData.roomNo"
                  class="w180"
                  :disabled="oneBuilRoom || startBuilRoom||dealDisable"
                  placeholder="請選擇單位"
                  no-data-text="暫無數據"
                >
                  <el-option
                    v-for="(item, index) in estAdress.unitList"
                    :key="index"
                    :label="item.roomNoWithCulture"
                    :value="item.roomNo"
                  />
                </el-select>
              </el-form-item>
              <!-- 独立屋等(234)手输单位 -->
              <el-form-item
                v-else
                label="單位"
              >
                <el-input
                  v-model="dealFormData.roomNo"
                  :disabled="dealDisable"
                  maxlength="20"
                  class="w180"
                />
              </el-form-item>
            </el-row>
          </template>
          <template v-else>
            <!-- 座数 楼层-->
            <el-row
              v-if="dealFormData.propertyCategory !== '5'"
              :gutter="20"
              class="flexbuilA-flo"
            >
              <div
                v-if="dealFormData.propertyCategory !== '4'"
                class="flexbuilA"
              >
                <el-form-item label="座數">
                  <el-input
                    v-model="dealFormData.buildingName"
                    :disabled="dealDisable"
                    class="w180"
                  />
                </el-form-item>
              </div>
              <div
                ref="unitFloor"
                :class="['flexflo', { flexCat: dealFormData.propertyCategory == 4 }]"
              >
                <el-form-item
                  label="樓層"
                  class="build-form"
                >
                  <el-select
                    v-model="dealFormData.unitFloor"
                    :disabled="dealDisable"
                    placeholder="請選擇高/中/低層"
                    no-data-text="暫無數據"
                    class="w180"
                  >
                    <el-option
                      v-for="item in diConfig.UnitFloor"
                      :key="item.dictionaryValue"
                      :label="item.dictionaryNameWithCulture"
                      :value="item.dictionaryValue"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </el-row>
            <!-- 单位 -->
            <el-row
              v-if="dealFormData.propertyCategory !== '5' && dealFormData.propertyCategory !== '4'"
              :gutter="20"
            >
              <el-form-item
                label="單位"
                class="build-form"
              >
                <el-input
                  v-model="dealFormData.roomNo"
                  :disabled="dealDisable"
                  maxlength="20"
                  class="w180"
                />
              </el-form-item>
            </el-row>
          </template>
          <!-- 樓盤地址 楼龄 -->
          <el-row :gutter="20">
            <el-form-item label="街道號碼">
              <el-input
                v-model="dealFormData.estateAddress"
                class="w180"
                :placeholder="dealFormData.estateID==0 ? ' 如:天湖路1號' : ''"
                :disabled="(dealFormData.estateID!=0 || (!Boolean(dealFormData.estateID) && mode == 'edit'))|| dealDisable"
                maxlength="20"
              />

              <div
                v-if="dealFormData.propertyCategory != '5'"
                class="build-Div"
              >
                <span>樓齡</span>
                <el-input
                  v-model="dealFormData.buildingAge"
                  class="w180"
                  :disabled="(dealFormData.estateID!=0 || JSON.stringify(EstateInfo) != '{}' )||dealDisable"
                  maxlength="20"
                  @input="onlyNumber(dealFormData.buildingAge, 'buildingAge')"
                />
              </div>
            </el-form-item>
          </el-row>

          <el-row :gutter="20">
            <el-form-item
              label="售價(萬)"
              prop="salePrice"
            >
              <el-input
                v-model.trim="dealFormData.salePrice"
                :disabled="dealDisable || !dealFormData.subCategory || (dealFormData.subCategory && dealFormData.subCategory.includes('19'))"
                class="w180"
                @blur="handleReqChange('salePrice', 'rentPrice')"
              />
              <!-- 已补未补皆存在时显示 -->
              <el-checkbox
                v-if="!dealFormData.rentPrice &&dealFormData.salePrice&& (dealFormData.subCategory.includes('6') || dealFormData.subCategory.includes('7') || dealFormData.subCategory.includes(6) || dealFormData.subCategory.includes(7)) && salePrice != unPaidSalePrice && dealFormData.unPaidSalePrice && isShowPriceBox "
                v-model="paidPriceBox"
                class="left_10 mr_r10"
                @change="changePaidPrice"
              >
                已補地價
              </el-checkbox>
              <div style="display: inline-block; line-height: 25px; vertical-align: middle; margin-left: 4px">
                <div>根據實際業務</div>
                <div>價格選擇填寫</div>
              </div>
            </el-form-item>
          </el-row>
          <el-row :gutter="20">
            <el-form-item
              label="租價(元)"
              prop="rentPrice"
            >
              <el-input
                v-model.trim="dealFormData.rentPrice"
                :disabled="dealDisable"
                class="w180"
                @blur="handleReqChange('rentPrice', 'salePrice')"
              />
            </el-form-item>
          </el-row>
          <el-row
            v-if="dealFormData.propertyCategory !== '4'"
            :gutter="20"
          >
            <el-form-item
              label="實用面積(呎)"
              prop="saleableArea"
            >
              <el-input
                v-model.trim="dealFormData.saleableArea"
                :disabled="dealDisable"
                class="w180"
                @blur="handleReqChange('saleableArea', 'buildingArea')"
              />
              <div style="display: inline-block; line-height: 25px; vertical-align: middle; margin-left: 4px">
                <div>實用面積和建築面積</div>
                <div>最少填寫一項</div>
              </div>
            </el-form-item>
          </el-row>
          <el-row
            v-if="dealFormData.propertyCategory !== '4'"
            :gutter="20"
          >
            <el-form-item prop="buildingArea">
              <template #label>
                <span>建築面積(呎)</span>
              </template>
              <el-input
                v-model.trim="dealFormData.buildingArea"
                :disabled="dealDisable"
                class="w180"
                @blur="handleReqChange('buildingArea', 'saleableArea')"
              />
            </el-form-item>
          </el-row>
          <el-row
            v-if="dealFormData.propertyCategory !== '4' && dealFormData.propertyCategory !== '5'"
            :gutter="20"
          >
            <el-form-item label="房間數目">
              <el-select
                v-model="dealFormData.roomNumber"
                :disabled="dealDisable"
                placeholder="不提供"
                no-data-text="暫無數據"
                class="w180"
              >
                <el-option
                  v-for="item in diConfig.RoomNumber"
                  :key="item.dictionaryValue"
                  :label="item.dictionaryNameWithCulture"
                  :value="item.dictionaryValue"
                  placeholder="不提供"
                />
              </el-select>
                                    
              <div
                v-if="dealFormData.propertyCategory !== '2' && dealFormData.propertyCategory !== '3'"
                class="build-Div tnumber"
              >
                <span>洗手間數目</span>
                <el-select
                  v-model="dealFormData.toiletNumber"
                  :disabled="dealDisable"
                  placeholder="不提供"
                  no-data-text="暫無數據"
                  class="w180"
                >
                  <el-option
                    v-for="item in diConfig.ToiletNumber"
                    :key="item.dictionaryValue"
                    :label="item.dictionaryNameWithCulture"
                    :value="item.dictionaryValue"
                    placeholder="不提供"
                  />
                </el-select>
              </div>
            </el-form-item>
          </el-row>
          <el-row :gutter="20">
            <el-form-item
              label="成交/註冊日期"
              prop="dealDate"
            >
              <el-date-picker
                v-model="dealFormData.dealDate"
                :disabled="dealDisable"
                value-format="yyyy-MM-dd"
                class="w180"
                type="date"
                placeholder="選擇日期"
              />
            </el-form-item>
          </el-row>
        </div>
      </div>
      <div class="thibox">
        <h3>其他資料</h3>
        <div class="content">
          <el-row :gutter="20">
            <el-form-item label="代理人名稱">
              <el-input
                v-model="dealFormData.agentName"
                placeholder=" "
                maxlength="20"
                class="w180"
              />
              <div class="build-Div">
                <span>代理人職位</span>
                <el-input
                  v-model="dealFormData.agentJobRole"
                  maxlength="20"
                  class="w180"
                />
              </div>
            </el-form-item>
          </el-row>
          <el-row
            :gutter="20"
            class="flexbuilA-flo"
          >
            <div class="flexbuilA">
              <el-form-item label="代理人聯絡電話">
                <el-input
                  v-model="dealFormData.agentPhone"
                  placeholder=" "
                  maxlength="20"
                  class="w180"
                  @input="onlyNumber(dealFormData.agentPhone,'agentPhone')"
                />
                <!-- <div class="build-Div">
                            <span>代理人牌照</span>
                            <el-input v-model="dealFormData.agentLicenceNumber" maxlength="20" class="w180"></el-input>
                        </div> -->
              </el-form-item>
            </div>
            <div class="flexflo">
              <el-form-item label=" ">
                <div class="build-Div">
                  <span>代理人牌照</span>
                  <el-input
                    v-model="dealFormData.agentLicenceNumber"
                    maxlength="20"
                    class="w180"
                  />
                </div>
              </el-form-item>
            </div>
          </el-row>
          <el-row :gutter="20">
            <el-form-item label="原業主購入價">
              <el-input
                v-model="dealFormData.ownerPurPrice"
                placeholder=" "
                maxlength="20"
                class="w180"
              />
              <div class="build-Div build-Divdate">
                <span>原業主購入日期</span>
                <el-date-picker
                  v-model="dealFormData.ownerPurDate"
                  value-format="yyyy-MM-dd"
                  class="w180"
                  type="date"
                  placeholder="選擇日期"
                />
              </div>
            </el-form-item>
          </el-row>
          <el-row
            :gutter="20"
            class="deal-rowo"
          >
            <el-form-item label="成交故事/單位特色">
              <el-input
                v-model="dealFormData.dealStory"
                class="w400"
                :rows="5"
                maxlength="300"
                type="textarea"
              />
              <span class="dealText">令你成交故事更吸引 例如: 移民急讓/ 蝕讓
                /減價求售/業主持貨多年/高價/低價/景觀/
                坐向/ 特色戶/ 連車位/連租約 /連花園/
                靚裝修</span>
            </el-form-item>
          </el-row>
          <el-row
            :gutter="20"
            class="deal-row"
          >
            <el-col :span="20">
              <el-form-item>
                <template #label>
                  <span class="labeltit">成交驗證文件或樓盤圖片<br>(如有提供會優先處理)</span>
                </template>
                <el-upload
                  ref="uploadFile"
                  :show-file-list="false"
                  class="upload-demo"
                  action="#"
                  accept=".docx,image/jpeg,image/png,.pdf"
                  :limit="20"
                  :http-request="upfiles"
                  :on-exceed="handleExceed"
                  :before-upload="beforeUpload"
                  :file-list="filelist"
                  :on-remove="onRemove" 
                  multiple
                >
                  <el-button
                    size="small"
                    type="primary"
                  >
                    上傳文件
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <div class="tip">
              支援格式：.pdf  .jpg  .png  .docx 最多20个
            </div>
          </el-row>
          <el-row class="image-row">
            <div class="c_button">
              <el-button
                type="primary"
                :disabled="showDocBtn || selectedImage.length === 0 || selectedImage.length > 1"
                plain
                @click="rotate(selectedImage[0], dealFormData.verifyFile[selectedImage[0]].filePath, 270)"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconzuoxuanzhuan" />
                </svg>
                旋轉
              </el-button>
              <el-button
                type="primary"
                :disabled="showDocBtn || selectedImage.length === 0 || selectedImage.length > 1"
                plain
                @click="rotate(selectedImage[0], dealFormData.verifyFile[selectedImage[0]].filePath, 90)"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconyouxuanzhuan" />
                </svg>
                旋轉
              </el-button>
              <el-button
                type="primary"
                plain
                :disabled="selectedImage.length === 0"
                @click="delPic()"
              >
                <svg
                  class="icon"
                  aria-hidden="true"
                >
                  <use xlink:href="#iconshanchu" />
                </svg>
                删除
              </el-button>
              <el-button
                type="primary"
                plain
                :disabled="showDocBtn || selectedImage.length === 0 || selectedImage.length > 1"
                @click="largeImg"
              >
                <i class="el-icon-zoom-in" /> 圖片預覽
              </el-button>
                            
              <el-button
                type="primary"
                :disabled="!showDocBtn || selectedImage.length === 0 || selectedImage.length > 1"
                plain
                @click="fetchPreviewBlob(fileUrl,fileType)"
              >
                <!-- <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#iconshanchu" />
                                </svg> -->
                文件預覽
              </el-button>
            </div>
            <div class="image">
              <!-- <draggable v-model="images" :disabled="draggableStart" @update="dragUpdate">
                        <transition-group> -->
              <div
                v-for="(item, index) in dealFormData.verifyFile"
                :key="index"
                class="img_warp"
              >
                <div
                  class="el-image"
                  :class="{ selected: selectedImage.includes(index) }"
                  @click="selected(index,item)"
                >
                  <div
                    v-if="item.filePath.split('.').pop().toLowerCase() == 'jpg'||item.filePath.split('.').pop().toLowerCase() == 'png' || item.filePath.split('.').pop().toLowerCase() == 'jpeg'"
                    class="imgpan"
                  >
                    <img
                      :src="item.filePath + '?x-oss-process=style/300xauto_f'"
                      alt
                      width="180"
                      height="135"
                    >
                  </div>
                  <div
                    v-if="item.filePath.split('.').pop().toLowerCase() == 'docx'"
                    class="imgspan"
                  >
                    <img
                      src="../../assets/DOCX.png"
                      alt
                    >
                    <div>{{ item.name }}</div>
                  </div>
                  <div
                    v-if="item.filePath.split('.').pop().toLowerCase() == 'pdf'"
                    class="imgspan"
                  >
                    <img
                      src="../../assets/PDF.png"
                      alt
                    >
                    <div>{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!-- </transition-group>
                    </draggable> -->
            </div>
          </el-row>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button
          class="retbtn"
          @click="returnDeal"
        >
          返回
        </el-button>
        <el-button
          v-if="$route.query.type !== 'edit'"
          class="canbtn"
          @click="cancelDeal"
        >
          清空
        </el-button>
        <el-button
          type="primary"
          @click="validation('dealFormData')"
        >
          提交
        </el-button>
      </div>
    </el-form>
    <el-dialog
      title="歷史刊登屋苑"
      :visible.sync="showDia"
      width="500px"
      :modal-append-to-body="false"
    >
      <div>
        <el-radio-group
          v-model="historyId"
          class="moreChooser"
        >
          <el-radio
            v-for="(item,index) in historyPro"
            :key="index"
            :label="index"
          >
            {{ item.estateName }}&nbsp;{{ item.phase }} &nbsp;{{ item.buildingName }}
          </el-radio>
        </el-radio-group>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeDialog">取 消</el-button>
        <el-button
          class="ch-button-left"
          type="primary"
          @click="confirmHisPro(historyId)"
        >確 認</el-button>
      </span>
      <!-- <div>
            <el-radio-group v-model="historyId" class="moreChooser">
                <el-radio :label="index" v-for="(item,index) in historyPro" :key="index">{{ item.estateName }}&nbsp;{{ item.phase }}</el-radio>
            </el-radio-group>
           </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button class="ch-button-left" type="primary" @click="confirmHisPro(historyPro[historyId].estateID)">確 認</el-button>
            </span> -->
    </el-dialog>
    <div
      v-if="enLarge"
      class="enLarge"
    >
      <span
        class="el-image-viewer__btn el-image-viewer__close"
        @click="enLarge = false"
      ><i class="el-icon-circle-close" /></span>
      <!-- <span class="el-image-viewer__btn el-image-viewer__prev" @click="changeImg('prev')"><i class="el-icon-arrow-left"></i></span>
            <span class="el-image-viewer__btn el-image-viewer__next" @click="changeImg('next')"><i class="el-icon-arrow-right"></i></span> -->
      <div class="el-image-viewer__canvas">
        <img
          ref="bigImg"
          :src="dealFormData.verifyFile[selectedImage[0]].filePath + '?x-oss-process=style/master'"
          class="el-image-viewer__img"
        >
      </div>
    </div>
  </div>
</template>

<script>
// import draggable from 'vuedraggable';

export default {
    components: {},
    data() {
        let cateSubValue = (rule, value, callback) => {
            if ((this.dealFormData.propertyCategory == 1 || this.dealFormData.propertyCategory == 5 || this.dealFormData.propertyCategory == 4) && Array.from(this.dealFormData.subCategory).length == 0) {
                callback(new Error('請選擇樓盤詳細類別'));
            } else {
                callback();
            }
        };
        let estNameValue = (rule, value, callback) => {
            if (!this.dealFormData.estateID) {
                if ((!this.dealFormData.estateName || this.dealFormData?.estateName?.trim().length == 0) && (!this.dealFormData.estateNameEN || this.dealFormData?.estateNameEN?.trim().length == 0)) {
                    callback(new Error('請輸入屋苑或大廈名稱'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        let floorNameValue = (rule, value, callback) => {
            // 屋苑单栋模式下 楼层为必填.其余类型均为星级盘要求必填
            if (this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType == 1) {
                if (!this.dealFormData.floorName) {
                    callback(new Error('請選擇樓層'));
                } else {
                    callback();
                }
                if (this.estAdress.unitFloorList.length && !this.dealFormData.unitFloor) {
                    callback(new Error('請選擇楼层补充资料'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        let buildValue = (rule, value, callback) => {
            if ((this.dealFormData.buildingNameWithCulture == '' || !this.dealFormData.buildingNameWithCulture) && this.isHaveTo) {
                callback(new Error('請選擇座數'));
            } else {
                callback();
            }
        };
        return {
            isShowPriceBox:true,
            unPaidSalePrice:'',
            showDocBtn:false,
            salePrice:'',
            selectedImage: [],
            mode: 'post',
            showDia :false,
            enLarge:false,
            historyId:'',
            historyPro:[],
            dealDisable:false,
            phoneDeal:'',
            paidPriceBox:false,
            diConfig: {
                PropertyCategory: [],
                ChildrenCategory: [],
                RoomNumber: [],
                ToiletNumber: []
            },
            dealFormData: {
                agentName:'',
                agentJobRole:'',
                agentPhone:'',
                agentLicenceNumber:'',
                ownerPurPrice:'',
                ownerPurDate:'',
                dealStory:'',
                phase:'',
                isHouseProperty: true,
                propertyID: '',
                phaseWithCulture: '',
                propertyCategoryArr: [],
                propertyCategory: '', // 放盘分类Int32
                subCategory: [], //小分类In32
                propertyNo: '',
                estateName: '',
                parentEstateID: '',
                estateID: '', //期数
                buildingName: '',
                buildingNameWithCulture: '',
                floorName: '',
                roomNo: '',
                buildingAge: '',
                estateAddress: '',
                salePrice: '',
                rentPrice: '',
                saleableArea: '',
                buildingArea: '',
                roomNumber: '',
                toiletNumber: '',
                dealDate: null,
                propertyID: null,
                verifyFile: []
            },
            filelist: [],
            fileUpCount:0,
            UpCount:0,
            isCutomadded: false, //搜索时判断是否村屋
            estateSrcList: [], //可选楼盘类型
            estAdress: {
                phaseEstates: [], //期数
                buildings: [], //座数
                floorList: [], //楼层
                unitList: [], //单位
                areaList: [], //使用面积
                unitFloorList: [] //楼层资料缺失补充
            },
            EstateInfo: {}, //楼盘信息搜索到的
            showEstAdressbui: true, //展示输入类型座数
            oneBuilFlo: false,
            startFloDis: true, // 初始进入页面切换楼盘类型时 楼层单位禁用
            startBuilRoom: true, //初始进入页面是否禁用
            oneBuilRoom: false, //单位是否禁用 根据选中屋苑判断
            rules: {
                estateNameAll: [{ required: true, validator: estNameValue, trigger: 'change' }],
                floorNameAll: [{ required: true, validator: floorNameValue, trigger: 'change' }],
                buildingNameWithCulture: [{ required: true, validator: buildValue, trigger: 'change' }],
                // propertyCategoryArr: [{ required: true, message: '請選擇樓盤類型', trigger: 'change' }],
                subCategory: [{ validator: cateSubValue, trigger: ['blur', 'change'] }],
                propertyCategory: [{ required: true, message: '必須選擇樓盤類型', trigger: 'change' }],
                // propertyNo: [{ required: true, message: '請填寫物業編號', trigger: 'blur' }],
                estateName: [{ required: true, message: '請選擇樓盤屋苑或大廈名稱', trigger: 'change' }],
                phaseWithCulture: [{ required: true, message: '請選擇期数', trigger: 'change' }],
                salePrice: [{ required: true, message: '請輸入放售價', trigger: 'blur' }],
                rentPrice: [{ required: true, message: '請輸入每月租金', trigger: 'blur' }],
                buildingArea: [{ required: true, message: '請輸入建築面積', trigger: 'blur' }],
                saleableArea: [{ required: true, message: '請輸入實用面積', trigger: 'blur' }],
                dealDate: [{ required: true, message: '請選擇成交/註冊日期', trigger: 'change' }]
            },
            phaseEstates: [],
            estate: [],
            floorList: [
                { dictionaryValue: 5, dictionaryNameWithCulture: '全棟' },
                { dictionaryValue: 1, dictionaryNameWithCulture: '高層' },
                { dictionaryValue: 2, dictionaryNameWithCulture: '中層' },
                { dictionaryValue: 3, dictionaryNameWithCulture: '低層' },
                { dictionaryValue: 4, dictionaryNameWithCulture: '地下' }
            ]
        };
    },
    computed: {
        isHaveTo() {
            if (this.dealFormData.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui) {
                return true;
            } 
                return false;
            
        }
    },
    async created() {
        this.mode = this.$route.query.type?'edit':'post'
        let res = await Promise.all([this.getAppConfig(), this.getDictionary()]);
        this.phoneDeal  = res[0].data.result.dealDes.replace('\\r\\n', '<br><br>');
        this.phoneDeal  = res[0].data.result.dealDes.replace('</ a>', '</a>');
        this.phoneDeal  = this.phoneDeal.replace(/\n/g, '<br>');
        let phoneLink = res[0].data.result.dealDesPhoneCode.replace(/\s/g, '')
        this.phoneDeal = this.phoneDeal.replace('phonecode',`<a href="https://api.whatsapp.com/send?phone=${phoneLink}" target="blank">${res[0].data.result.dealDesPhoneCode}</a>`);
        res[1].PropertyCategory.children.pop()//不展示大湾区/海外
        this.diConfig.PropertyCategory = res[1].PropertyCategory.children
        this.diConfig.UnitFloor = res[1].UnitFloor.children;
        this.diConfig.RoomNumber = res[1].RoomNumber.children;
        this.diConfig.ToiletNumber = res[1].ToiletNumber.children;
        this.diConfig.RoomNumber.unshift({
            dictionaryNameWithCulture: '不提供',
            dictionaryValue: null
        });
        if(this.mode == 'edit'){
            this.editDeal(this.$route.query.dealId)
        }else{
            if(this.dealFormData.isHouseProperty){
                this.dealDisable = true
            }
        }
        this.diConfig.PropertyCategory.forEach(item => {
            if (item.dictionaryValue === this.dealFormData.propertyCategory) {
                this.diConfig.ChildrenCategory = item.children;
            }
        });
    },
    methods: {
        changePaidPrice(){
            if(!this.paidPriceBox && this.dealFormData.unPaidSalePrice){
                this.dealFormData.salePrice = this.dealFormData.unPaidSalePrice
            }else{
                this.dealFormData.salePrice = this.salePrice
            }
        },
        fetchPreviewBlob(fileurl,type) {
            let url = fileurl.replace(/^https?:\/\//i, '//');
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    if(type == 'application/msword'){
                        let docwindow = window.open('', 'DetailRunTime'); // 创建新窗口
                        let box = document.createElement('div'); // 创建一个div
                        let docx = require('docx-preview');
                        docx.renderAsync(blob, box)
                            .then(() => {
                                docwindow.document.write(box.outerHTML);
                                docwindow.document.title = '成交文档'; // 窗口标题
                                docwindow.document.getElementsByClassName('docx')[0].style.width = 'auto';
                            })
                            .catch(error => console.error(error)); // 添加对错误处理的代码
                    }else{
                        const finalBlob = new Blob([blob], { type: type })
                        const href = window.URL.createObjectURL(finalBlob); //创建下载的链接
                        window.open(href);
                    }
                });
        },
        rotate(index, url, angle) {
            let urls = url.indexOf('?x-oss-process') > -1 ? url : url + '?x-oss-process=style/master-nowater';
            this.axios
                .post(this.pub.getApi().RotateImage, {
                    url: urls,
                    degrees: angle
                })
                .then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.dealFormData.verifyFile[index].filePath = res.data.result[0].url;
                }
                });
        },
        largeImg() {
            this.enLarge = true;
        },
         delPic() {
            this.selectedImage.sort(function (a, b) {
                return b - a;
            });
            this.selectedImage.forEach(item => {
                this.dealFormData.verifyFile.splice(item, 1);
            });
            this.selectedImage = [];
        },
        selected(index,item) {
            let temp = this.selectedImage.indexOf(index);
            if (temp > -1) {
                this.selectedImage.splice(temp, 1);
            } else {
                this.selectedImage.push(index);
            }
            this.fileType= ''
            this.fileUrl = ''
            if(this.selectedImage.length == 1 && (this.dealFormData.verifyFile[this.selectedImage[0]].filePath.split('.').pop().toLowerCase() == 'docx' || this.dealFormData.verifyFile[this.selectedImage[0]].filePath.split('.').pop().toLowerCase() == 'pdf')){
                this.showDocBtn = true
                this.fileUrl = this.dealFormData.verifyFile[this.selectedImage[0]].filePath
                this.fileType = this.dealFormData.verifyFile[this.selectedImage[0]].filePath.split('.').pop().toLowerCase() == 'docx' ? 'application/msword': 'application/pdf'
            }else{
                this.showDocBtn = false
            }
        },
        changeIsHouse(){
            this.$forceUpdate()
            this.resetPhamore('ishouse')
            this.cateFromEstate();
            if(!this.dealFormData.isHouseProperty){
                this.dealFormData.propertyID = ''
                this.dealDisable = false
            }else{
                this.dealDisable = true
            }
        },
        addformrule(){
            this.rules.salePrice = [{ required: true, message:'請輸入放售價', trigger: 'blur' }];
            this.rules.rentPrice = [{ required: true, message: '請輸入每月租金', trigger: 'blur' }];
            this.rules.buildingArea= [{ required: true, message: '請輸入建築面積', trigger: 'blur' }];
            this.rules.saleableArea = [{ required: true, message: '請輸入實用面積', trigger: 'blur' }];
        },
        confirmHisPro(id){
           this.resetPhamore()
           this.dealDisable = false

           let arr =  this.historyPro[id]
           this.showDealData(arr)
           this.showDia = false
        },
        closeDialog(){
            this.showDia = false
        },
        async showDealData(dealData){
            this.mode = 'edit'
            if (dealData.buildingArea) {
                this.rules.saleableArea[0].required = false;
            }
            if (dealData.saleableArea) {
                this.rules.buildingArea[0].required = false;
            }

            // 修改 2: 处理 rentPrice/salePrice 的校验逻辑
            if (dealData.salePrice) {
                this.rules.rentPrice = [{ required: false, message: '', trigger: 'blur' }];
            } else {
                this.rules.salePrice = [{ required: false, message: '', trigger: 'blur' }];
            }
            // dealData.buildingArea ? (this.rules.saleableArea[0].required = false) : '';
            // dealData.saleableArea ? (this.rules.buildingArea[0].required = false) : '';
            // dealData.salePrice ? (this.rules.rentPrice = [{ required: false, message: '', trigger: 'blur' }]) : (this.rules.salePrice = [{ required: false, message: '', trigger: 'blur' }]);
            this.dealFormData = Object.assign(this.dealFormData,  dealData);
            this.dealFormData.roomNumber = this.dealFormData.roomNumber?.toString()
            this.dealFormData.toiletNumber = this.dealFormData.toiletNumber?.toString()
            this.dealFormData.propertyCategory = this.dealFormData.propertyCategory?.toString()
           
            if(this.dealFormData.ownerPurDate.indexOf('0001-01-01')){
                this.dealFormData.ownerPurDate = this.dealFormData.ownerPurDate.split('T')[0];  
            }else{
                this.dealFormData.ownerPurDate= ''
            }
            if (this.dealFormData.propertyCategory == '5' || this.dealFormData.propertyCategory == '4') {
                if(this.dealFormData.subCategory[0] != 0){
                    this.dealFormData.subCategory = Object.values(this.dealFormData.subCategory).map(String);
                }
                this.dealFormData.subCategory = []
            }else{
                if(this.dealFormData.subCategory.includes('6') || this.dealFormData.subCategory.includes('7') || this.dealFormData.subCategory.includes(6) || this.dealFormData.subCategory.includes(7)){
                    this.dealFormData.subCategory =  this.dealFormData.subCategory.filter(item => item === 6 || item === 7);
                }
                this.dealFormData.subCategory = String(this.dealFormData.subCategory[0]);
            }
            this.dealFormData.unitFloor = this.dealFormData.unitFloor?.toString()
            this.filelist = this.dealFormData.verifyFile;
            this.dealFormData.salePrice = parseInt(this.dealFormData.salePrice / 10000)
            
            if(this.dealFormData.subCategory && this.dealFormData.subCategory.includes('19')){
                this.dealFormData.salePrice = ''
            }
            if(this.dealFormData.subCategory && (this.dealFormData.subCategory.includes('6') || this.dealFormData.subCategory.includes('7')|| this.dealFormData.subCategory.includes(6) || this.dealFormData.subCategory.includes(7))){
                this.salePrice = this.dealFormData.salePrice
                if(this.dealFormData.unPaidSalePrice){
                    this.dealFormData.unPaidSalePrice = parseInt(this.dealFormData.unPaidSalePrice / 10000)
                    this.unPaidSalePrice = this.dealFormData.unPaidSalePrice
                }
                if(this.dealFormData.salePrice && this.dealFormData.salePrice != this.dealFormData.unPaidSalePrice ){
                    this.paidPriceBox = true
                }
                // 不存在已补，只有未补，则显示未补。两个都有默认显示已补。
                if(!this.dealFormData.salePrice && this.dealFormData.unPaidSalePrice){
                    this.dealFormData.salePrice = this.dealFormData.unPaidSalePrice
                }

            }
            await this.axios
                .get(this.pub.getApi().GetEstate, {
                    params: { estateId: this.dealFormData.estateID }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.estateSrcList = res.data.result.estateSrcList;
                        this.cateFromEstate()
                    }
                });
            await this.getPhaBuild(this.dealFormData)
            if((this.dealFormData.propertyCategory == 1 || this.dealFormData.propertyCategory == 2)&& !this.isCutomadded && !this.dealFormData.buildingNameWithCulture && this.showEstAdressbui){
                this.buildingsList.forEach(it => {
                if (it.buildingName === this.dealFormData.buildingName) {
                    this.dealFormData.buildingNameWithCulture = it.buildingNameWithCulture
                }
            });
            }
            if( this.dealFormData.estateID && this.dealFormData.buildingNameWithCulture && (this.dealFormData.propertyCategory == 1 || this.dealFormData.propertyCategory == 2)){
                let bid = this.buildingsList.filter(item => item.buildingNameWithCulture ==this.dealFormData.buildingNameWithCulture )
                this.dealFormData.buildingType = bid[0]?.buildingType ?bid[0].buildingType:''
                this.dealFormData.buildingID = bid[0]?.buildingID?bid[0]?.buildingID:''
                this.dealFormData.buildingAddress = bid[0]?.buildingAddress?bid[0]?.buildingAddress:''
            }
            this.setBuild(this.dealFormData)
            this.diConfig.PropertyCategory.forEach(item => {
                if (item.dictionaryValue === this.dealFormData.propertyCategory) {
                    this.diConfig.ChildrenCategory = item.children;
                }
            });
            //! 报错:Invalid prop: type check failed for prop "fileList". Expected Array, got String with value ""
            for (const key in this.dealFormData) {
                if (this.dealFormData[key] !== false && (this.dealFormData[key] == 0 && !this.dealFormData.propertyCategory == 4) && key!=='verifyFile' && key !== 'agentPhone') {
                    this.dealFormData[key] = ''
                }
            }
        },
        async editDeal(id){
            await this.axios.post(this.pub.getApi().SearchPropertyDeal, {propertyDealID:id,pageIndex:1,pageCount:1}).then(res => {
                if (res.data.code == 0) {
                    this.showDealData(res.data.result.data[0])
                }
            });
        },
        seaPro(sourceID){
            this.axios.get(this.pub.getApi().GetPropertyUpdateGroupLogs + `?propertyId=${sourceID}`).then(res => {
                if (res.data.code == 0 && res.data.result) {
                    // 存在多个历史屋苑
                    // this.historyPro = []
                    if(res.data.result.length>1){
                        this.showDia = true
                        // for (let i = 0; i < res.data.result.length; i++) {
                        //      let str = res.data.result[i].estateName +  res.data.result[i].phase
                        //      this.historyPro.push(str)
                        // }
                        this.historyPro = res.data.result
                    }else{
                        this.resetPhamore()
                        this.dealDisable = false
                        this.showDealData(res.data.result[0])
                    }
                    this.isShowPriceBox = true
                } else if (res.data.code != 0) {
                    this.$message({
                        message: '樓盤編號不存在',
                        type: 'error',
                        showClose: true
                    });
                }
            });
        },
        clearForm(){
            this.$refs.dealFormData.resetFields();
            this.dealFormData.verifyFile = [];
            this.dealFormData.isHouseProperty = true;
            this.filelist = [];
            this.selectedImage = []
            this.dealDisable = true
            this.dealFormData = { ...this.dealFormData };
            this.addformrule()
        },
        returnDeal(){
            this.$router.push('/property/dealData')
        },
        cancelDeal() {
        this.$confirm('確認後將清空所有輸入的內容。<br/>繼續清空嗎？', '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        showClose:false,
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose:true,
        type: 'warning'
      }).then(async () => {
        this.clearForm()
      }).catch(action => {
      })
        },
        dataFormat() {
            for (const key in this.dealFormData) {
                if (this.dealFormData[key] === '' || JSON.stringify(this.dealFormData[key]) === '[]' || this.dealFormData[key] === null) {
                    delete this.dealFormData[key];
                    continue;
                }
                
            }
            if(this.dealFormData.propertyCategory == 1){
                this.dealFormData.subCategory = [parseInt(this.dealFormData.subCategory)];
            }
            this.dealFormData.salePrice = this.dealFormData.salePrice * 10000
        },
        async validation(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    if(this.fileUpCount != this.UpCount){
                        this.warning("文件正在上傳中,請稍後提交")
                        return
                    }
                    this.dataFormat();
                    if (this.$route.query.type && this.$route.query.type == 'edit') {
                           await this.axios.post(this.pub.getApi().UpdatePropertyDeal, this.dealFormData).then(res => {
                            if (res.data.code == 0) {
                                this.success('成交數據修改成功');
                                this.$router.push('/property/dealData')
                            } else {
                                this.error('成交數據修改失敗');
                            }
                        });
                        
                    } else {
                        await this.axios.post(this.pub.getApi().AddPropertyDeal, this.dealFormData).then(res => {
                            if (res.data.code == 0) {
                                this.success('成交數據提交成功');
                                this.$router.push('/property/dealData')
                            } else {
                                this.error('成交數據提交失敗');
                            }
                        });
                    }
                } else {
                    this.error('成交資料不完整，請根據提示補充資料');
                    return false;
                }
            });
        },
        onRemove(file, fileList) {
            for (let index = 0; index < this.dealFormData.verifyFile.length; index++) {
                if (file.uid == this.dealFormData.verifyFile[index].uid) {
                    this.dealFormData.verifyFile.splice(index, 1);
                }
            }
        },
        beforeUpload(file) {
            if (file.size === 0) {
                this.warning('圖片上傳失敗，請重新上傳');
                return false;
            }
            if (file.size > 20971520) {
                this.warning('檔案大小必須20MB以下');
                return false;
            }
            if (!file.name.toLocaleLowerCase().match(/(.*)\.(jpg|png|docx|pdf)$/)) {
                this.warning('支援格式：JPG, PNG, DOCX, PDF');
                return false;
            }
            if (this.dealFormData.verifyFile.length > 20) {
                this.dealFormData.verifyFile = this.dealFormData.verifyFile.length.splice(0, 20);
                this.warning('已超過圖片上傳數量限制');
            }
            file.arrayBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: file.type });
                let formData = new FormData();
                formData.append('file', blob, file.name);
                this.axios.post(this.pub.getApi().Upload, formData).then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.dealFormData.verifyFile.push({
                            name: file.name,
                            filePath: res.data.result[0].url
                        });
                    }
                    if(res.data.code !== 0){
                        this.error("请重新上傳")
                    }
                    this.UpCount = ++this.UpCount
                });
            });
        },
        handleExceed(files, fileList) {
            this.warning('已超過文件上傳數量限制');
        },
        async upfiles(value){
            this.fileUpCount = ++this.fileUpCount
        },
        onlyNumber(value, key) {
            if (!key) {
                return value.replace(/[^\d]/g, '');
            }
            this.dealFormData[key] = value.replace(/[^\d]/g, '');
            this.$forceUpdate();
        },
        setFloExt() {
            this.$forceUpdate();
            this.dealFormData.roomNo = '';
            // 单位是否禁用
            if (this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType == 1) {
                // 当第一个楼层缺失 单位一定禁用
                if (this.dealFormData.floorName == '' || !this.dealFormData.floorName) {
                    this.oneBuilRoom = true;
                } else {
                    // 楼盘资料缺失的情况下-判断第二个楼层选择框
                    if (this.estAdress.unitFloorList.length && (!this.dealFormData.unitFloor || this.dealFormData.unitFloor == '')) {
                        this.oneBuilRoom = true;
                    } else {
                        this.oneBuilRoom = false;
                        this.startBuilRoom = false;
                    }
                }
            } else {
                this.startBuilRoom = false;
                this.oneBuilRoom = false;
            }
        },
        changeSub() {
            this.dealFormData.salePrice = this.dealFormData.subCategory && this.dealFormData.subCategory.includes('19') ?'':this.dealFormData.salePrice
            this.$forceUpdate()
        },
        onlyOneSel() {
            if (this.mode !== 'edit') {
                if (this.estAdress.phaseEstates.length == 1 && this.dealFormData.propertyCategory == '1') {
                    this.dealFormData.phaseWithCulture = this.estAdress.phaseEstates[0].phaseWithCulture;
                    this.setPhaBuild('phase', this.estAdress.phaseEstates[0]);
                }
                if (this.estAdress.buildings.length == 1 && this.dealFormData.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui) {
                    this.dealFormData.buildingNameWithCulture = this.estAdress.buildings[0].buildingNameWithCulture;
                    this.setPhaBuild('build', this.estAdress.buildings[0]);
                }
            }
        },
        norBuilTypeOne(type) {
            if ((this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType !== 1) || this.mode == 'edit') {
                this.oneBuilRoom = false;
                this.startBuilRoom = false;
                this.startFloDis = false;

                this.oneBuilFlo = false;
            }
        },
        geteditRoomNo() {
            if(this.estAdress.floorList && this.estAdress.floorList.length){
                for (let index = 0; index < this.estAdress.floorList.length; index++) {
                    if (this.dealFormData.floorName == this.estAdress.floorList[index].floorName) {
                        this.estAdress.unitList = this.estAdress.floorList[index].roomResponses;
                    }
                }
            }
        },
        setFlo(item) {
            this.dealFormData.roomNo = '';
            if (item.unitFloor) {
                if (this.dealFormData.buildingType == '1') {
                    this.dealFormData.unitFloor = String(item.unitFloor);
                } else {
                    this.dealFormData.unitFloor = item.unitFloor;
                }
            }
            this.dealFormData.floorNameEN = item.floorNameEN;
            this.dealFormData.unitFloorWithCulture = item.unitFloorWithCulture;
            if (item.roomResponses) {
                this.estAdress.unitList = item.roomResponses;
            }
            // 单位是否禁用
            if (this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType == 1) {
                // 当第一个楼层缺失 单位一定禁用
                if (this.dealFormData.floorName == '' || !this.dealFormData.floorName) {
                    this.oneBuilRoom = true;
                } else {
                    // 楼盘资料缺失的情况下-判断第二个楼层选择框
                    if (this.estAdress.unitFloorList.length && (!this.dealFormData.unitFloor || this.dealFormData.unitFloor == '')) {
                        this.oneBuilRoom = true;
                    } else {
                        this.oneBuilRoom = false;
                        this.startBuilRoom = false;
                    }
                }
            } else {
                this.oneBuilRoom = false;
                this.startBuilRoom = false;
            }
        },
        // 获取楼层
        getFloor(item) {
            return new Promise((suc, err) => {
                this.axios
                    .get(this.pub.getApi().GetBuildingFloorPublish, {
                        params: { buildingId: item.buildingID }
                    })
                    .then(res => {
                        this.estAdress.floorList = res.data.result;
                        // 仅有一个楼层的时候 默认选中
                        if (this.mode !== 'edit') {
                            if (this.dealFormData.buildingType == '1' && this.estAdress.floorList.length == 1 && this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType == 1) {
                                this.setFlo(this.estAdress.floorList[0]);
                            }
                        }
                        if (this.mode == 'edit') {
                            this.geteditRoomNo();
                        }
                        if (res.data.result && res.data.result[0] && !res.data.result[0].floorDisplay) {
                            this.axios
                                .get(this.pub.getApi().SearchDictionaryInfo, {
                                    params: { itemName: 'UnitFloor' }
                                })
                                .then(response => {
                                    this.estAdress.unitFloorList = response.data.result;
                                });
                        } else {
                            this.estAdress.unitFloorList = [];
                        }
                        suc();
                    });
            });
        },
        setBuild(item) {
            this.dealFormData.buildingNameEN = item.buildingNameEN;
            this.dealFormData.buildingName = item.buildingName;
            if (this.dealFormData.propertyCategory == '1') {
                this.dealFormData.buildingType = item.buildingType;
            }
            this.dealFormData.buildingID = item.buildingID;
            this.getFloor(item);
            // 先选座数 期数被反选
            if (this.estAdress.phaseEstates) {
                this.estAdress.phaseEstates.forEach(it => {
                    if (item.estateID == it.estateID) {
                        this.dealFormData.phaseWithCulture = it.phaseWithCulture;
                        // this.dealFormData.buildingAge = it.buildingAge ? it.buildingAge : 0;
                        this.dealFormData.estateID = it.estateID;
                        this.dealFormData.phaseEstateId = it.estateID;
                        this.dealFormData.parentEstateID = it.parentEstateID;
                        this.dealFormData.gscopeCode = it.gscopeCode;
                        this.dealFormData.regionNameWithCulture = it.regionNameWithCulture;
                        this.dealFormData.gscopeNameWithCulture = it.gscopeNameWithCulture;
                    }
                });
            }
            if ((this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType == 1) || (this.dealFormData.propertyCategory == '2' && this.showEstAdressbui && !this.isCutomadded)) {
                this.dealFormData.estateAddress = item.buildingAddress;
                this.dealFormData.buildingAge = item.buildingAge ? item.buildingAge : 0;
            }

            // 将楼层和单位恢复禁用
            this.norBuilTypeOne();

            // 楼层是否禁用
            if (this.dealFormData.propertyCategory == '1' && this.dealFormData.buildingType == 1) {
                if (!this.dealFormData.buildingNameWithCulture || this.dealFormData.buildingNameWithCulture == '') {
                    this.oneBuilFlo = true;
                } else {
                    this.startFloDis = false;
                    this.oneBuilFlo = false;
                }
            }
        },
        setPhaBuild(type, item) {
            this.dealFormData.floorNameWithCulture = '';
            this.dealFormData.floorName = '';
            this.dealFormData.floorNameEN = '';
            this.dealFormData.unitFloorWithCulture = '';
            this.estAdress.floorList = [];
            this.estAdress.unitFloorList = [];
            this.dealFormData.roomNo = '';
            this.estAdress.unitList = [];
            this.dealFormData.unitFloor = '';
            if (type == 'build') {
                this.setBuild(item);
                // 楼层是否禁用
            } else if (type == 'phase') {
                // 更新期数之后 座数置空
                this.dealFormData.estateID = item.estateID;
                this.dealFormData.buildingName = '';
                this.dealFormData.buildingID = '';
                this.dealFormData.buildingNameWithCulture = '';
                this.dealFormData.buildingNameEN = '';
                this.dealFormData.phaseEstateId = item.estateID;
                this.dealFormData.parentEstateID = item.parentEstateID;
                this.dealFormData.estateAddress = item.detailAddressWithCulture;
                this.dealFormData.buildingAge = item.buildingAge ? item.buildingAge : 0;
                this.dealFormData.gscopeCode = item.gscopeCode;
                this.dealFormData.regionNameWithCulture = item.regionNameWithCulture;
                this.dealFormData.gscopeNameWithCulture = item.gscopeNameWithCulture;
                // 根据期数筛选座数
                this.estAdress.buildings = this.buildingsList.filter(it => {
                    return it.estateID == item.estateID;
                });
                if (this.estAdress.buildings.length == 1 && this.dealFormData.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui) {
                    this.dealFormData.buildingNameWithCulture = this.estAdress.buildings[0].buildingNameWithCulture;
                    this.setPhaBuild('build', this.estAdress.buildings[0]);
                }
                this.showEstAdressbui = this.estAdress.buildings.length ? true : false;
                if (!this.showEstAdressbui) {
                    this.dealFormData.buildingType = 2;
                    this.norBuilTypeOne();
                }
            }
        },
        async setEstate(item) {
            this.dealFormData.estateName = item.estateNameWithCulture;
            // 楼盘地址栏 置空
            this.resetPhamore();
            await this.axios
                .get(this.pub.getApi().GetEstate, {
                    params: { estateId: item.estateID }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.EstateInfo = res.data.result;
                        this.estateSrcList = this.EstateInfo.estateSrcList;
                        this.dealFormData.estateID = this.EstateInfo.estateID;
                        this.dealFormData.estateType = this.EstateInfo.estateType; //bigest
                        this.dealFormData.gscopeCode = this.EstateInfo.gscopeCode;
                        this.dealFormData.regionNameWithCulture = this.EstateInfo.regionNameWithCulture; /*获取区域 草稿箱列表展示使用*/
                        this.dealFormData.gscopeNameWithCulture = this.EstateInfo.gscopeNameWithCulture; /*获取板块 草稿箱列表展示使用*/
                        this.dealFormData.buildingAge = this.EstateInfo.buildingAge ? this.EstateInfo.buildingAge : '';
                        this.dealFormData.estateAddress = this.EstateInfo.detailAddressWithCulture;
                        this.dealFormData.estateName = this.EstateInfo.estateNameWithCulture;
                        this.isCutomadded = this.EstateInfo.isCutomadded;
                        if (this.dealFormData.estateType === 'bigest') {
                            this.getPhase(this.dealFormData.estateID);
                        }
                    }
                });

            // 当选中屋苑+期数时,期数自动补充
            if (item.parentEstateID) {
                this.dealFormData.phaseWithCulture = item.phaseWithCulture;
            }
            // 获取期/座 筛选项
            await this.getPhaBuild(item);

            // 获取当前楼盘资料
            if (this.dealFormData.propertyCategory == '1') {
                this.startFloDis = true;
                this.startBuilRoom = true;
                this.oneBuilRoom = false;
            }
            // 期 座 只存在一个的时候, 默认选中第一个
            this.onlyOneSel();
            // 在住宅筛选项下,存在楼层数据仅有屋苑单栋(1)和独立屋(2)
            if (!this.showEstAdressbui) {
                this.dealFormData.buildingType = 2;
                this.norBuilTypeOne();
            }
            this.cateFromEstate();
        },
        getPhaBuild(item) {
            return new Promise((suc, err) => {
                this.axios
                    .get(this.pub.getApi().GetPhasesAndBuildingForPublish, {
                        params: { estateId: item.parentEstateID ? item.parentEstateID : item.estateID }
                    })
                    .then(res => {
                        if (res.data.result.estate) {
                            this.isCutomadded = res.data.result.estate.isCutomadded;
                        }
                        this.estAdress.phaseEstates = res.data.result.estatePhases;
                        this.buildingsList = res.data.result.buildingResponses;
                        this.estAdress.buildings = res.data.result.buildingResponses;
                        // 存在期数时 筛选座数筛选项
                        if (item.phaseWithCulture) {
                            this.estAdress.buildings = this.buildingsList.filter(it => {
                                return it.estateID == item.estateID;
                            });
                        }
                        this.showEstAdressbui = this.estAdress.buildings.length ? true : false;
                        suc();
                    });
            });
        },
        getPhase(EstateId) {
            this.axios
                .post(this.pub.getApi().SearchEstate, {
                    parentEstateId: EstateId,
                    order: 'PhaseSequenceAsc', // 按期数排序
                    pageIndex: 1,
                    pageCount: 20,
                    estateSrc: this.dealFormData.propertyCategory
                })
                .then(res => {
                    if (res.data.code == 0 && res.data.result) {
                        this.diConfig.phaseList = res.data.result.data;
                        if (this.diConfig.phaseList.length) {
                            this.$set(this.dealFormData, 'estateType', 'bigest');
                            this.diConfig.phaseList.unshift({
                                phaseWithCulture: '請選擇期數',
                                // estateID: this.dealFormData.estateID
                                estateID: this.mode == 'edit' && this.dealFormData.parentEstateID ? this.dealFormData.parentEstateID : this.dealFormData.estateID
                            });
                        }
                    }
                });
        },
        cateFromEstate(typefrom) {
            // 编辑时 可修改楼盘类型
            if (this.dealFormData.estateName) {
                for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
                    this.$set(this.diConfig.PropertyCategory[i], 'disable', true);
                }
                this.estateSrcList.forEach(it => {
                    for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
                        if (this.diConfig.PropertyCategory[i].dictionaryValue == String(it)) {
                            this.$set(this.diConfig.PropertyCategory[i], 'disable', false);
                        }
                    }
                });
                // 当屋苑名称和楼盘类型不匹配
                if (!this.estateSrcList.includes(parseInt(this.dealFormData.propertyCategory))) {
                    this.dealFormData.propertyCategory = '';
                    this.dealFormData.subCategory = [];
                }
            }
            if (this.dealFormData.estateName == '') {
                for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
                    this.$set(this.diConfig.PropertyCategory[i], 'disable', false);
                }
            }

            if (typefrom == 'conditions') {
                for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
                    this.$set(this.diConfig.PropertyCategory[i], 'disable', true);
                }
            }
        },
        /** 搜索楼盘 */
        search(queryString, callback) {
            // 当屋苑置空的时候 楼盘类型不能有禁用
            if (!queryString && this.dealFormData.estateName == '') {
                this.resetPhamore();
                this.cateFromEstate();
            }
            //   if ((this.mode == 'edit') && !queryString && this.dealFormData.estateName == '') {
            //     this.cateFromEstate()
            //   }
            if (!queryString) {
                return;
            }
            this.axios
                .post(this.pub.getApi().SearchEstate, {
                    keywords: queryString,
                    pageIndex: 1,
                    pageCount: 50,
                    parentEstateId: 0,
                    estateSrc: this.dealFormData.propertyCategory
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.estate = res.data.result.data;
                        this.estate
                            .sort((a, b) => {
                                if (!a.phaseWithCulture && b.phaseWithCulture) {
                                    return -1;
                                } else if (a.phaseWithCulture && !b.phaseWithCulture) {
                                    return 1;
                                }
                                return 0;
                            })
                            .map(item => {
                                const { gscopeNameWithCulture, estateNameWithCulture, phaseWithCulture } = item;
                                item.value = gscopeNameWithCulture + ' ' + estateNameWithCulture + ' ' + (phaseWithCulture ? phaseWithCulture : '');
                                return item;
                            });
                        callback(this.estate);
                    }
                });
        },
        proChange(e) {
            this.dealFormData.propertyNo = this.dealFormData.propertyNo.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '');
            this.$forceUpdate();
        },
        setChildType(item) {
            this.diConfig.ChildrenCategory = item.children;
            this.dealFormData.subCategory = [];
            // 当不为住宅 解除单位禁用
            if (item.dictionaryValue !== '1') {
                this.startFloDis = false;
                this.startBuilRoom = false;
            } else {
                this.startFloDis = true;
                this.startBuilRoom = true;
            }
            this.resetPhamore('category');
        },
        resetPhamore(type) {
            let recoverId = this.dealFormData.parentEstateID ? this.dealFormData.parentEstateID : this.dealFormData.estateID;
            if(type == 'ishouse'){
                this.dealFormData.estateName = ''
                this.dealFormData.estateID = ''
                this.dealFormData.parentEstateID = '';
                this.dealFormData.propertyNo = ''
                this.dealFormData.propertyCategory = ''
                this.dealFormData.subCategory = []
            }
            // 楼盘类型 屋苑名 下方清空 estatename
            // 下四项 刊登时规则为 只有在修改了屋苑名称后才会清空的
            this.estateSrcList= []
            this.dealFormData.estateAddress = ''
            this.dealFormData.dealStory='';
            this.dealFormData.salePrice='';
            this.dealFormData.rentPrice='';
            this.dealFormData.dealDate=null;
            this.dealFormData.buildingArea = '';
            this.dealFormData.saleableArea = '';

            this.dealFormData.buildingType = '';
            this.dealFormData.phaseWithCulture = '';
            this.dealFormData.phaseEstateId = '';
            this.dealFormData.parentEstateID = '';
            this.dealFormData.buildingAge = '';
            this.dealFormData.buildingID = '';
            this.dealFormData.buildingName = '';
            this.dealFormData.buildingNameWithCulture = '';
            this.dealFormData.buildingNameEN = '';
            this.dealFormData.floorName = '';
            this.dealFormData.floorNameEN = '';
            this.dealFormData.unitFloorWithCulture = '';
            this.dealFormData.roomNo = '';
            this.propertyDisPlayList = [];
            this.dealFormData.propertyDisPlayType = '';
            this.dealFormData.unitFloor = '';
            this.dealFormData.roomNumber = '';
            this.dealFormData.toiletNumber = '';
            this.dealFormData.toiletNumberWithCulture = '';
            // this.dealFormData.verifyFile = [];
            // this.filelist = [];
            this.addformrule()
            //修改楼盘类型清空期座后 楼龄与楼盘地址 须和当前屋苑数据一致
            if (recoverId && type == 'category') {
                this.recoverAdrAge(recoverId);
            }
        },
        async recoverAdrAge(item) {
            if (!this.dealFormData.estateName) {return};
            await this.axios
                .get(this.pub.getApi().GetEstate, {
                    params: { estateId: item }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.dealFormData.buildingAge = res.data.result.buildingAge ? res.data.result.buildingAge : '';
                        this.dealFormData.estateAddress = res.data.result.detailAddressWithCulture;
                    }
                });
        },
        getDictionary() {
            return this.pub.getDictionary();
        },
        getAppConfig() {
            return this.axios.get(this.pub.getApi().GetAppConfig, { params: { version: 'config' } });
        },
        cancelSearch() {
            this.dealFormData.estateName = '';
            this.resetPhamore()
            this.cateFromEstate()
        },
        phachange(item) {
            this.dealFormData.estateID = item.estateID;
        },
        handleReqChange(typeData, requiredType) {
            //面積 價格 為數字
            this.dealFormData[typeData] = this.dealFormData[typeData].replace(/[^\d]/g, '');
            if ((typeData == 'salePrice' || typeData == 'rentPrice') && this.dealFormData[typeData] <= 0) {
                this.dealFormData[typeData] = '';
            }
            if (this.dealFormData[typeData]) {
                if(typeData == 'salePrice'){
                    // 价格只要修改过 勾选框即隐藏
                    if(this.dealFormData.salePrice && this.salePrice != this.unPaidSalePrice && this.dealFormData.salePrice != this.salePrice  ){
                        this.isShowPriceBox = false
                    }else if(!this.dealFormData.salePrice && this.dealFormData.unPaidSalePrice && this.dealFormData.salePrice != this.unPaidSalePrice ){
                        this.isShowPriceBox = false
                    }
                    // 不存在已补，只有未补，则显示未补。两个都有默认显示已补。
                    if(!this.dealFormData.salePrice && this.dealFormData.unPaidSalePrice){
                        this.dealFormData.salePrice = this.dealFormData.unPaidSalePrice
                    }
                }
                this.rules[requiredType] = [{ required: false, message: '', trigger: 'blur' }];
                this.$refs.dealFormData.clearValidate(requiredType);
                if (typeData == 'salePrice' || typeData == 'rentPrice') {this.dealFormData[requiredType] = '';}
            } else if (!this.dealFormData[typeData] && !this.dealFormData[requiredType]) {
                let array = [
                    { key: 'salePrice', value: '請輸入放售價', requiremes: '請輸入每月租金' },
                    { key: 'rentPrice', value: '請輸入每月租金', requiremes: '請輸入放售價' },
                    { key: 'buildingArea', value: '請輸入建築面積', requiremes: '請輸入實用面積' },
                    { key: 'saleableArea', value: '請輸入實用面積', requiremes: '請輸入建築面積' }
                ];
                let selArr = array.filter(item => item.key == typeData);
                this.rules[requiredType] = [{ required: true, message: selArr[0].requiremes, trigger: 'blur' }];
                this.rules[typeData] = [{ required: true, message: selArr[0].value, trigger: 'blur' }];
            }
        },
        warning(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'warning',
        offset: document.body.clientHeight / 2
      });
    },
        success(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'success',
        offset: document.body.clientHeight / 2
      });
    },
    error(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'error',
        offset: document.body.clientHeight / 2
      });
    },
    }
};
</script>

<style scoped lang="less">
@theme-color: #0064ff;
@bgc-grey: #fafafb;
.retbtn{
    background-color: #BBBBBB ;
    color:#fff !important;
}
.canbtn{
    background-color: #E1C999 ;
    color:#fff !important;
}
/deep/.el-dialog__header {
    padding: 9px 32px;
    background: @bgc-grey;
    border-bottom: 1px solid #e2e2ea;
    .el-dialog__title {
        line-height: 24px;
        font-size: 16px;
        color: #666666;
        font-weight: 600;
    }
    .el-dialog__header__btn {
        top: 14px;
    }
}
    .moreChooser{
        /deep/.el-radio{
        margin-bottom:20px;
        display:block;
        }
    }
    
.dialog-footer {
            .el-button {
                width: 98px;
                height: 38px;
                border-radius: 10px;
                border-color: #dbdbdb;
                color: #444444;
            }
            .el-button--primary {
                color: #fff;
                background-color: @theme-color;
                border-color: @theme-color;
            }
            .el-button ~ .el-button {
                margin-left: 15px;
            }
        }
    /deep/.el-dialog {
        border-radius: 10px;
        overflow: hidden;
        text-align:left;
    }
/deep/.el-form-item__error {
    margin-left: 20px;
}

.el-row:not(:last-child) {
    margin-bottom: 20px;
}

.el-row {
    height: 46px;
    line-height: 46px;
}

.el-form {
    position: relative;
}

.el-form-item {
    margin-bottom: 0;
}
.w200 {
    width: 200px;
}
.w150 {
    width: 150px;
}
.w180 {
    width: 180px;
}
.w320 {
    width: 320px;
}
.w400 {
    width: 400px;
}
.w120 {
    width: 120px;
}
.left_10 {
    margin-left: 10px;
}
.mr_r10{
    margin-right: 10px;
    font-size: 14px;
    color: #171725;
}
/deep/.el-input__inner{
    border-radius:15px;
    background:#FAFAFB;
    height:46px;
}
/deep/.el-textarea__inner{
    border-radius:15px;
    background:#FAFAFB;
}
/deep/.el-form-item__label {
    margin-right: 20px;
    font-size: 16px;
    padding:0;
    color: #171725;
    // font-weight: 600;
}

/deep/.el-col {
    margin-left: -10px;
}
/deep/.el-form-item__content {
    text-align: left;
}
.enLarge {
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 999;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .el-icon-circle-close {
        color: #fff;
    }

    img {
        opacity: none;
        transform: scale(1) rotate(0deg);
        margin-left: 0px;
        margin-top: 0px;
        max-height: 80%;
        // max-width: 100%;
    }
}
.container {
    h3 {
        text-align: left;
    }
    .public () {
        // max-width: 1122px;
        overflow: hidden;
        margin-top: 30px;
        border-radius: 10px;
        border: 1px solid #e2e2ea;

        // padding: 5px;
        h3 {
            height: 42px;
            margin: 0;
            line-height: 42px;
            padding-left: 20px;
            font-weight: normal;
            font-size: 16px;
            background: rgba(80, 181, 255, 0.1);
            color: #696974;
        }

        .content {
            height: auto;
            padding-bottom: 20px;
            background: white;
            padding-top: 30px;
            box-sizing: border-box;
            span {
                font-size: 15px;
                color: #171725;
                // font-weight: 600;
            }
            .build-Div {
                display: inline-block;
                font-size: 14px;
                color: #171725;
                margin-left: 102px;
                span {
                    margin-right: 23px;
                }
                .build-sel {
                    margin-left: 10px !important;
                    margin-right: 3px;
                }
                .imgTip {
                    vertical-align: text-top;
                }
            }
            .build-Div-flo{
                margin-left:0;
            }
        }
    }
    h3 {
        height: 42px;
        margin: 0;
        line-height: 42px;
        padding-left: 20px;
        font-weight: normal;
        font-size: 16px;
        background: rgba(80, 181, 255, 0.1);
        color: #696974;
    }

    .content {
        height: auto;
        padding-bottom: 20px;
        background: white;
        padding-top: 30px;
        box-sizing: border-box;

        span {
            font-size: 15px;
            color: #171725;
        }
    }

    .boxtit {
        text-align: left;
        font-size: 24px;
        color: #171725;
        margin-bottom: 20px;
    }
    .boxcon {
        text-align: left;
        font-size: 16px;
        color: #444444;
        margin-bottom: 20px;
        a{
            color:#0062FF;
        }
    }
    .secbox {
        .public();
        .content {
            .cate {
                margin-bottom: 30px;
                height: auto;
                .moreChoose {
                    line-height: 10px;
                    margin-left: 20px;
                    margin-bottom: 10px;
                }
            }
            .propertyNo {
                margin-top: 35px;
                span.EAA {
                    font-size: 14px !important;
                    color: #696974 !important;
                    font-weight: normal !important;
                    height: 40px;
                    display: inline-block;
                    vertical-align: bottom;
                    line-height: 40px;
                }
            }
            
        }
        .tnumber{
            margin-left:68px !important;
        }
    }
    .firbox {
        .public();
        .content {
            padding-left: 40px;
        }
        .serBtn{
            margin-left:15px;
        }
    }
    .dialog-footer{
        height:51px;
        margin-top :40px;
        line-height:40px;
        text-align:left;
        button{
            width:95px;
            height:38px;
            border-radius:12px;
        }
    }
    .thibox {
        background:#fff;
        padding-bottom:10px;
        .public();
        .flexbuilA-flo{
            .flexflo{
                /deep/.el-form-item__content{
                    margin-left: -75px!important;
                }
            }
        }
        .content {
            padding-left: 40px;
            .dealText{
                display:inline-block;
                width:260px;
                line-height:28px;
                margin-left:10px;
                font-size:14px;
                color:#696974;
            }
            .deal-rowo{
                height:120px;
            }
            .image-row{
                height:auto;
                text-align:left;
                .c_button {
                    display: inline-block;
                    margin-left:226px;

                    .el-button[disabled] {
                        .icon_xz {
                            font-size: 16px;
                        }
                    }
                }
            }
            .image {
            margin: 10px 0 0 219px;
            max-width: 750px;
            padding: 0;

        .img_warp {
            box-sizing: border-box;
            position: relative;
            font-size: 12px;
            list-style: none;
            display: inline-block;
            margin-right: 10px;
            display: inline-flex;
            flex-direction: column;
            margin-bottom: 10px;
            vertical-align:top;
            .selected {
                border: 2px solid #0062ff !important;
            }
            .descWidth {
                /deep/ textarea {
                    resize: none;
                }

                width: 100%;
            }

            /deep/.el-input__inner {
                font-size: 12px;
            }

            .el-select {
                margin-bottom: 6px;
            }

            .el-input {
                margin-bottom: 10px;
            }

            .selected {
                border: 2px solid #0062ff !important;
            }

            .el-image {
                width: 180px;
                height: 135px;
                border-radius: 5px;
                margin-bottom: 10px;
                background: #ccc;
                text-align: center;
                vertical-align: middle;
                font-size: 14px;
                cursor: pointer;

                span {
                    display: inline-block;
                    margin: 30px auto;
                    color: #fff;
                    font-weight: normal;
                }
                .imgpan{
                    vertical-align:top;
                    img{
                        margin:0;
                    }
                }
                .imgspan{
                    width:178px;
                    height:127px;
                    margin:0;
                    background: #fff;
                    padding-top:5px;
                    border:1px solid #ccc;
                    border-radius:5px;
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    img{
                        width:107px;
                        height:101px;
                        margin:0;
                    }
                    div{
                        height:28px;
                        margin-top:-10px;
                        font-size:12px;
                        max-width:100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }

            img {
                width: 180px;
                height: 135px;
                border-radius: 5px;
                margin-bottom: 10px;
                border: 2px solid transparent;
                box-sizing: border-box;
            }

            .icon_left {
                font-size: 22px;
                transform: rotate(90deg);
                background: rgba(0, 0, 0, 0.3);
                position: absolute;
                top: 3px;
                left: 3px;
            }

            .icon_right {
                position: absolute;
                font-size: 22px;
                transform: rotate(-90deg);
                background: rgba(0, 0, 0, 0.3);
                top: 3px;
                left: 25px;
            }
        }
    }

            .deal-row {
                width: 960px;
                position: relative;
                .labeltit{
                    display:inline-block;
                    height:40px;
                    line-height:30px;
                }
                .tip{
                    position:absolute;
                    top:0;
                    left:327px;
                    font-size:14px;
                    color:#444444;
                }
                .upload-demo{
                    display:inline-block;
                    margin-right: 8px;
                    span{
                        color:#444444;
                        font-size: 14px;
                    }
                    
                }
            }
        }
        .build-Div{
            margin-left:210px !important;
        }
        .build-Divdate{
            margin-left:182px !important;
        }
    }
    .flexbuilA-flo {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                .flexbuilA {
                    width: 496px;
                }
                .flexCat {
                    margin-left: 158px;
                }
                .flexflo {
                    /deep/ .el-form-item__label {
                        width: 56px !important;
                    }
                    /deep/.el-form-item__content {
                        margin-left: 79px !important;
                    }
                }
            }
}
</style>
